module.exports = {
    expired_1: "انتهت صلاحية الرابط",
    limit_time: "عرض محدود الوقت لـ",
    participate: "شارك في حدث التقييم الآن للحصول على مكافأتك الحصرية!",
    exclusive: "حصري",
    reward: "مكافأة",
    token: "رموز",
    vip: "يوم VIP",
    after_completing: "بعد إكمال التقييم والتحقق من لقطة الشاشة، ستحصل على",
    step_1: "<strong style='color: #000000'>انقر على الزر أدناه</strong> لزيارة متجر التطبيقات و<strong style='color: #000000'>ترك تقييم 5 نجوم.</strong>",
    step_2: "بعد إكمال التقييم، يرجى <strong style='color: #000000'>التقاط لقطة شاشة</strong> لمحتوى تقييمك.",
    step_3: "<strong style='color: #000000'>قم بتحميل لقطة الشاشة</strong> أدناه وأرسل معرفك داخل التطبيق لاستلام مكافأتك.",
    click_to: "1. انقر للذهاب إلى ",
    upload: "2. تحميل لقطة شاشة التقييم",
    app_store: "متجر التطبيقات",
    google_play: "متجر Google Play",
    go_to: "اذهب إلى ",
    example: "مثال على لقطة الشاشة",
    upload_screenshot: "تحميل لقطة الشاشة",
    claim: "المطالبة بالمكافأة",
    verification_inprogress: "شكرًا لك على التحميل. يتم مراجعة لقطة الشاشة الخاصة بك في أسرع وقت ممكن. يرجى التحلي بالصبر.",
    verification_success: "مبروك! <br/><br/> لقد طالبت بمكافأتك بنجاح. سيتم إضافة المكافأة إلى حسابك <strong>في غضون 24 ساعة.</strong> يرجى متابعتها. <br/><br/> إذا كان لديك أي أسئلة، فلا تتردد في الاتصال بدعم العملاء.",
    verification_failed: "يجب أن تفي لقطة شاشة التقييم بالشروط التالية: <br/><br/> <div style='margin-left: 6px'> 1.يجب أن يكون التقييم 5 نجوم والمحتوى إيجابيًا. <br/><br/> 2.يجب أن يتم التقييم على <strong> Apple App Store أو Google Play Store. </strong> <br/><br/> 3.يجب أن تعرض لقطة الشاشة محتوى التقييم بالكامل، بما في ذلك <strong> الصورة الرمزية، واسم المستخدم، ونص التقييم. <strong></div>",
    reupload: "إعادة الرفع",
}